import React from 'react';
import { Platform, View } from 'react-native';
import { KeyboardToolbar } from 'react-native-keyboard-controller';

/** Altura da barra acima do teclado (iOS); o scroll reserva esse espaço. */
export const KEYBOARD_BAR_HEIGHT = Platform.OS === 'ios' ? 42 : 0;

/**
 * Barra fina acima do teclado no iOS: anterior / próximo campo e "Concluir".
 * O teclado numérico e o de telefone do iOS não têm tecla de retorno — sem
 * ela não há como fechar o teclado e o botão de salvar fica escondido.
 * Fica fora da tela enquanto o teclado está fechado. Montada uma vez no
 * `app/_layout.tsx`; não aparece dentro de `Modal` (outra janela).
 */
export function KeyboardBar() {
  if (Platform.OS !== 'ios') return null;
  return (
    <View pointerEvents="box-none" style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
      <KeyboardToolbar doneText="Concluir" />
    </View>
  );
}
